<template>
  <div>
    <div></div>
  </div>
</template>
<style scoped>

</style>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {
    const { user_email, ts, type, token } = this.$route.query;
    let datas = {
      user_email: user_email,
      ts: ts,
      type: type,
      token:token
    };
    this.submitForm(datas);
    console.log("22222", this.$route.query);
  },
  mounted() {
    this.$emit("outLogin", {});
  },
  methods: {
    submitForm(data) {
      this.$api.rootV1.post(
        "/web/user/adminlogin/check", data,
        (res) => {
          const access_token = res.data.token;
          this.$util.saveToken(access_token);
          this.$util.saveRole("admin");
          this.$emit("logged", {});
          this.$util.save("menus", res.data.access.menu);
          this.$util.save("user_email", data.user_email);
          this.$util.save("user_type", res.data.access.user_type);
          this.$router.push({ path: res.data.access.home_page, query: {} });
        },
        (res) => {
          console.log("res2:", res);
          this.$message.error(res.errmsg);
        }
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/LoginLink.vue